export default "__VITE_ASSET__c8137270__"